import { render, staticRenderFns } from "./PurchaseList_List.vue?vue&type=template&id=39c14850&"
import script from "./PurchaseList_List.vue?vue&type=script&lang=js&"
export * from "./PurchaseList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports